import { List } from "semantic-ui-react";
import { WidgetProps } from "@rjsf/core";
import { FileView } from "../../../../../sg-fileupload";
import { Form } from "semantic-ui-react";
import { FieldHeader } from "../../components/FieldHeader";
import { useSchemaTranslation } from "../../../../hooks/useSchemaTranslation";

function FileUploadWidget({
  id,
  value,
  placeholder,
  formContext,
  label
}: WidgetProps) {

  const { t } = useSchemaTranslation();

  return (
    <Form.Field>
      {label && <FieldHeader> {t(label)} </FieldHeader>}
      {value && value.length ? (
        value.map((file: any) => (
          <List.Item key={file.id}>
            <FileView
              title={file.name}
              id={file.id}
            />
          </List.Item>
        ))
      ) : <div>{placeholder || formContext.emptyValue}</div>}
    </Form.Field>
  );

};

export default FileUploadWidget;
